module.exports = "<div ng-cloak ng-if=\"$ctrl.showDiscount()\" class=\"c-membership  c-membership__banner\" ng-class=\"{ 'c-membership__header' : $ctrl.header }\">\n    <span ng-if=\"!$ctrl.short\">\n        Your membership discount is currently active and will be applied during the payment step of the checkout\n    </span>\n    <span ng-if=\"$ctrl.short\">\n        Your membership discount will show on the payment screen before completion\n    </span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/basket/views/membershipBanner.html
// module id = 701
// module chunks = 0